import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/homeData';

export default function FeaturedArticles() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm">最受欢迎的内裤选购知识与技巧</p>
          </div>
          <Link
            to="/category/all"
            className="inline-flex items-center text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-white/90 text-primary-500 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500 pt-3 border-t border-background-200/60">
                  <span>{article.date}</span>
                  <span className="flex items-center">
                    <i className="ri-time-line mr-1"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}